<script>
import baseMixin from '@/mixins/baseMixin'
import FormSubmissionWithSchemaVM from '@/models/forms/formSubmissionWithSchemaVM'
import FormSubmissionFieldControl from './form-submission-field-control.vue'
import FormSubmissionStateLabel from './form-submission-state-label.vue'
import FormSubmissionDownloadPdfBtn from './form-submission-download-pdf-btn.vue'
import FormSubmissionDownloadStampedPdfBtn from './form-submission-download-stamped-pdf-btn.vue'

export default {
  name: 'FormSubmissionDetails',
  components: {
    FormSubmissionFieldControl,
    FormSubmissionStateLabel,
    FormSubmissionDownloadPdfBtn,
    FormSubmissionDownloadStampedPdfBtn,
  },
  mixins: [baseMixin],
  props: {
    form: {
      type: FormSubmissionWithSchemaVM,
      required: true,
    },
    passkey: {
      type: String,
      default: null,
    },
  },
  computed: {
    schema() {
      return this.form.schema
    },
    submission() {
      return this.form.submission
    },
    submissionPasskey() {
      return this.passkey ?? this.$route.params.passkey
    },
  },
  methods: {
    getSubmissionValueByKey(key) {
      if (!this.submission) {
        return null
      }
      const foundValue = this.submission.values[key]
      return foundValue || foundValue === 0 ? foundValue : null
    },
  },
}
</script>

<template>
  <div>
    <v-card class="rounded-xl custom-elevation pb-4 px-2">
      <v-card-title class="mb-0 pb-0 d-flex align-center justify-space-between">
        <BasePageTitle :title="schema.name" :subtitle="schema.description">
          <template v-slot:title>
            <BasePageTitleHeader>
              {{ schema.name }}
              <span class="caption opacity-8">
                version {{ schema.versionNo }}
              </span>
              <FormSubmissionStateLabel
                v-if="submission"
                :state="submission.state"
              />
            </BasePageTitleHeader>
          </template>
        </BasePageTitle>

        <div v-if="submission" class="mb-5"
          ><FormSubmissionDownloadPdfBtn
            :passkey="submissionPasskey" /><FormSubmissionDownloadStampedPdfBtn
            :passkey="submissionPasskey"
            :has-pdf-configuration="schema.formDefinition.hasPdfConfiguration"
        /></div>
      </v-card-title>
      <v-card-text
        v-for="group of schema.formDefinition.groups"
        :key="group.key"
      >
        <h6 class="text-h6 my-2">{{ group.label }}</h6>
        <p class="text-body-2 font-weight-medium">{{ group.description }}</p>
        <v-divider />
        <FormSubmissionFieldControl
          v-for="field of group.fields.filter((field) => !field.hidden)"
          :key="field.key"
          class="mt-6"
          :field="field"
          :value="getSubmissionValueByKey(field.key)"
        />
      </v-card-text>
    </v-card>
  </div>
</template>
